export enum CloudFileStatus {
    PrepForQc = 1,
    PrepQcFailed = 2,
    InQc = 3,
    QcDone = 4,
    Rejected = 5,
    WaitingForClientResponse = 6
}

export const mapToCloudFileStatus = (status: number | string): CloudFileStatus => {
    const numberStatus = Number(status);

    if (numberStatus in CloudFileStatus) {
        return numberStatus;
    }

    throw new Error("Incorrect cloud file status.");
};

export const isInvalidStatusForQcDone = (status: CloudFileStatus): boolean =>
    [
        CloudFileStatus.Rejected,
        CloudFileStatus.QcDone,
        CloudFileStatus.PrepForQc,
        CloudFileStatus.PrepQcFailed
    ].includes(status);

export const isInvalidStatusForWaitingForClientResponse = (status: CloudFileStatus): boolean =>
    status !== CloudFileStatus.InQc;

export const isInvalidStatusForReject = (status: CloudFileStatus): boolean =>
    [CloudFileStatus.Rejected, CloudFileStatus.QcDone, CloudFileStatus.PrepForQc].includes(status);
